import { appBasePath } from './app'

export const radioSections = {
  podcast: {
    id_section: 10,
    section: 'Podcast',
    section_alias: 'podcast',
    section_icon: 'icon-radio1',
    category: 'Podcast',
    category_alias: 'podcast',
    category_icon: '',
    reel: appBasePath + '/assets/images/reel_podcast.jpg',
    reelMobile: appBasePath + '/assets/images/reel_podcast_mobile.jpg',
    categories: {
      detail: [
        {
          id_category: '46',
          category: 'Actualidad',
          category_alias: 'actualidad',
          category_icon: '',
          reel: '',
          reelMobile: ''
        },
        {
          id_category: '47',
          category: 'Entretenimiento',
          category_alias: 'entretenimiento',
          category_icon: '',
          reel: '',
          reelMobile: ''
        },
        {
          id_category: '48',
          category: 'Deportes',
          category_alias: 'deportes',
          category_icon: '',
          reel: '',
          reelMobile: ''
        }
      ],
      alias: [
        'deportes',
        'actualidad',
        'entretenimiento'
      ]
    }
  },
  radio: {
    id_section: 9,
    section: 'Radio',
    section_alias: 'radio',
    section_icon: 'icon-radio1',
    reel: '',
    reelMobile: '',
    categories: {
      detail: [
        {
          id_category: '32',
          category: 'Especiales',
          category_alias: 'especiales',
          category_icon: '',
          reel: appBasePath + '/assets/images/reel_specials.jpg',
          reelMobile: appBasePath + '/assets/images/reel_specials_mobile.jpg'
        },
        {
          id_category: '34',
          category: 'Playlist',
          category_alias: 'playlist',
          category_icon: '',
          reel: appBasePath + '/assets/images/reel_playlist.jpg',
          reelMobile: appBasePath + '/assets/images/reel_playlist_mobile.jpg'
        },
        {
          id_category: '39',
          category: 'DJs',
          category_alias: 'djs',
          category_icon: '',
          reel: appBasePath + '/assets/images/reel_djs.jpg',
          reelMobile: appBasePath + '/assets/images/reel_djs_mobile.jpg'
        },
        {
          id_category: '49',
          category: 'Tops',
          category_alias: 'tops',
          category_icon: '',
          reel: '',
          reelMobile: ''
        }
      ],
      alias: [
        'especiales',
        'playlist',
        'djs',
        'tops'
      ]
    }
  }
}

export const radioCategories = [
  {
    category: 'Podcast',
    category_alias: 'podcast',
    category_icon: '',
    id_category: '27',
    id_section: '4',
    section: 'Podcast',
    section_alias: 'podcast',
    section_icon: 'icon-radio1',
    reel: appBasePath + '/assets/images/reel_podcast.jpg',
    reelMobile: appBasePath + '/assets/images/reel_podcast_mobile.jpg'
  },
  {
    category: 'Especiales',
    category_alias: 'especiales',
    category_icon: '',
    id_category: '32',
    id_section: '4',
    section: 'Radio',
    section_alias: 'radio',
    section_icon: 'icon-radio1',
    reel: appBasePath + '/assets/images/reel_specials.jpg',
    reelMobile: appBasePath + '/assets/images/reel_specials_mobile.jpg'
  },
  {
    category: 'Playlist',
    category_alias: 'playlist',
    category_icon: '',
    id_category: '34',
    id_section: '4',
    section: 'Radio',
    section_alias: 'radio',
    section_icon: 'icon-radio1',
    reel: appBasePath + '/assets/images/reel_playlist.jpg',
    reelMobile: appBasePath + '/assets/images/reel_playlist_mobile.jpg'
  },
  {
    category: 'DJs',
    category_alias: 'djs',
    category_icon: '',
    id_category: '39',
    id_section: '4',
    section: 'Radio',
    section_alias: 'radio',
    section_icon: 'icon-radio1',
    reel: appBasePath + '/assets/images/reel_djs.jpg',
    reelMobile: appBasePath + '/assets/images/reel_djs_mobile.jpg'
  }
]
